define(function (require, exports, module) {
    var EMPTY = '';

    function ContentAudio (audio) {
        audio = audio.item || audio;
        this.id = audio.id;
        this.language = (audio.language || EMPTY).toLowerCase();
        this.team = (audio.type || EMPTY).toLowerCase();
        this.mediaState = audio.mediaState;
        this.name = this.callLetters = audio.callLetters;
        this.guid = audio.guid;
        this.mediaUrls = audio.mediaUrls;
        this.contentId = audio.contentId;
    }

    return ContentAudio;
});
